const SMS_LIMITS = [
  { credits: 1, maxChars: 160 },
  { credits: 2, maxChars: 306 },
  { credits: 3, maxChars: 459 },
  { credits: 4, maxChars: 612 },
  { credits: 5, maxChars: 765 },
  { credits: 6, maxChars: 918 },
  { credits: 7, maxChars: 1071 },
  { credits: 8, maxChars: 1224 }
];

const MAX_SMS_CHARS = 1224;

export const SMSCreditCounter = ({ charCount = 0, className = "" }) => {
  const getCreditsInfo = count => {
    if (count === 0) {
      return { credits: 0, boundary: 160, isOverLimit: false };
    }

    for (const limit of SMS_LIMITS) {
      if (count <= limit.maxChars) {
        return {
          credits: limit.credits,
          boundary: limit.maxChars,
          isOverLimit: false
        };
      }
    }

    return {
      credits: 8,
      boundary: MAX_SMS_CHARS,
      isOverLimit: true
    };
  };

  const { credits, boundary, isOverLimit } = getCreditsInfo(charCount);
  const isAtLimit = charCount === MAX_SMS_CHARS;
  const isNearLimit = charCount >= 1071 && charCount < MAX_SMS_CHARS;

  const getStatusStyle = () => {
    if (isOverLimit) {
      return { color: "#ff4d4f", fontWeight: "bold" };
    }
    if (isAtLimit) {
      return { color: "#ff4d4f", fontWeight: "bold" };
    }
    if (isNearLimit) {
      return { color: "#faad14", fontWeight: "600" };
    }
    return { color: "#666" };
  };

  return (
    <div
      className={`flex items-center p-2 mt-2 text-xs ${className}`.trim()}
      style={{ ...getStatusStyle() }}
    >
      {isOverLimit ? (
        <span>
          ⚠️ LIMIT EXCEEDED - {charCount}/{MAX_SMS_CHARS} chars (max 8 credits)
        </span>
      ) : (
        <span>
          {credits} credit{credits !== 1 ? "s" : ""} - {charCount}/{boundary} chars
          {isAtLimit && " ⚠️ MAX LIMIT REACHED"}
          {isNearLimit && !isAtLimit && " (approaching limit)"}
        </span>
      )}
    </div>
  );
};